import * as Assets from "Data/Assets";
import { TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { zeplinSprite } from "Utils/zeplinSprite";
export class MusicGameBackground extends PIXI.Container {
    constructor() {
        super();

        const bg = HLF.PixiUtils.makeSprite(Assets.MUS_BG);
        const lanternsLeft = zeplinSprite({
            "name": "mus-lanterns-left",
            "rect": {
                "x": 4.5,
                "y": 0,
                "width": 291.5,
                "height": 166.5
            }
        }, Assets.SPRITESHEET_MUSIC_GAME);
        const lanternsRight = zeplinSprite({
            "name": "mus-lanterns-right",
            "rect": {
                "x": 1391,
                "y": 0,
                "width": 257.5,
                "height": 175
            }
        }, Assets.SPRITESHEET_MUSIC_GAME);

        // centered
        this.addChild(bg);

        // top left
        const container = this.addChild(new PIXI.Container());
        container.pivot.set(1664 / 2, 768 / 2);
        container.addChild(lanternsLeft);
        container.addChild(lanternsRight);
        TweenLite.from(container, 1, {pixi: {scale: 1.1}});
    }

}